import styled from 'styled-components';
import { GRAYSCALE_200, NEUTRAL_100 } from '@styles/colors';

export const Container = styled.div`
  width: 100%;
  padding: 18px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 16px;
`;

export const EmptyContainer = styled.div`
  width: 100%;
  padding-top: 15%;
  height: 70vh;
  background-color: ${GRAYSCALE_200};
  border: 1px solid ${NEUTRAL_100};
  border-radius: 16px;
`;

export const ItemContainer = styled.div`
  /* Container for each activity item */
`;

export const Divider = styled.div`
  height: 1px;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: ${NEUTRAL_100};
`;

// Skeleton components
export const SkeletonContainer = styled(Container)`
  /* Inherits from Container */
`;

export const SkeletonItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const SkeletonIconContainer = styled.div`
  display: flex;
`;

export const SkeletonDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

export const SkeletonLeftSide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`;

export const SkeletonRightSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
`;
